import dayjs from 'dayjs'
import _ from 'lodash'

class ProcessTimeSlots {
    constructor({item, appointmentType, patientCount, patients, serviceTimes, widgetAvailability, shifts, administrator}){
        if(!appointmentType){
            return {value: {}}
        }
        
        let lengths = (appointmentType.durations || '').split(",")
        this.spacer = appointmentType.spacer
        this.duration = (lengths[patientCount - 1] || 30)
        this.item = {
            ...item,
            startsAt: dayjs(item.startsAt),
            endsAt: dayjs(item.endsAt)
        }

        if(widgetAvailability){
            let values = widgetAvailability.split("_")
            this.targetDate = dayjs().add(values[1],values[2])
            this.targetType = values[0] 
            if(values[2] == 'hours'){
                this.targetDate = this.targetDate.add(1,'hour').startOf('hour')
            } else {
                this.targetDate = this.targetDate.startOf('day')
            }
        }

        this.setCurrentStart(this.item.startsAt.clone())
        this.setCurrentEnd(this.item.startsAt.clone().add(this.duration, 'minutes'))

        let matchingServiceTimes = []
        if(serviceTimes.length > 0){
            let serviceTimeFound = false
            serviceTimes.forEach((serviceTime)=>{
                let dayMatch = serviceTime.startsAt.format("MM/DD/YYYY") == this.currentStart.format("MM/DD/YYYY")
                let timeMatch = this.item.startsAt.isBefore(serviceTime.endsAt) && this.item.endsAt.isAfter(serviceTime.startsAt)
                if(dayMatch && timeMatch){
                    serviceTimeFound = true
                    matchingServiceTimes.push(serviceTime)
                }
            })

            if(!serviceTimeFound){
                return {value: []}
            }
        }

        if(matchingServiceTimes.length > 0){
            matchingServiceTimes = _.sortBy(matchingServiceTimes, ["startsAt", "endsAt"])
            let firstMatchingTime = matchingServiceTimes[0]
            let firstStartsAt = firstMatchingTime.startsAt
            if(firstStartsAt.isAfter(this.currentStart)){
                this.setCurrentStart(firstStartsAt.clone())
                this.setCurrentEnd(firstStartsAt.clone().add(this.duration, 'minutes'))
            }
        }

        let timeSlots = {}

        let unrestricted = {}
        let restricted = {}
        if(!patients) patients = []
        for(let restrictionTimeKey of Object.keys(this.item.summary || {})){
            for(let restrictionKey of Object.keys(this.item.summary[restrictionTimeKey])){
                let rules = {...this.item.summary[restrictionTimeKey][restrictionKey]}
                for(let patient of patients){
                    if(patient.birthday){
                        patient.age = dayjs().diff(patient.birthday, 'months') / 12
                    }
                    let ruleMatch = true
                    let reverseRule = false
                    for(let [keyID, value] of Object.entries(rules)){
                        let key = keyID.split("--")[0]
                        if(key != 'available' && !_.isNil(patient[key])){
                            let [operator,target] = value.split('--')
                            switch(operator){
                                case '<':
                                    if(patient[key] >= parseFloat(target)) ruleMatch = false
                                    break;
                                case '>':
                                    if(patient[key] <= parseFloat(target)) ruleMatch = false
                                    break;
                                case '<=':
                                    if(patient[key] > parseFloat(target)) ruleMatch = false
                                    break;
                                case '>=':
                                    if(patient[key] < parseFloat(target)) ruleMatch = false
                                    break;
                                case '==':
                                    if(patient[key] != target) ruleMatch = false
                                    break;
                                case '!=':
                                    if(!reverseRule && patient[key] != target){
                                        ruleMatch = false
                                    } else {
                                        ruleMatch = true
                                        reverseRule = true
                                    } 
                                    break;
                            }
                        }
                    }
                    if(ruleMatch){
                        if(!reverseRule && (rules.available || 0) < patients.length){
                            restricted[restrictionTimeKey] = true
                        } else {
                            unrestricted[restrictionKey] = true
                        }
                    }
                }
                delete rules.available
            }
        }
        let maxPatients
        if(administrator){
            maxPatients = (administrator.administratorOptions || {}).maxPatientsPerTimeSlot || 1
        }
        while(this.currentEnd.isBefore(this.item.endsAt) || this.currentEnd.isSame(this.item.endsAt)){
            let timeRestricted = false
            let unavailable = false
            if(Object.keys(this.item.summary || {}).length > 0){
                timeRestricted = true
            }
            for(let restrictionTimeKey of Object.keys(this.item.summary || {})){
                if(!unavailable){
                    let [ruleStartsAt, ruleEndsAt] = restrictionTimeKey.split('--')
                    if(this.currentStart.isBefore(dayjs(ruleEndsAt)) && this.currentEnd.isAfter(dayjs(ruleStartsAt))){
                        if(restricted[restrictionTimeKey]){
                            unavailable = true
                        } else if(timeRestricted){
                            for(let restrictionKey of Object.keys(this.item.summary[restrictionTimeKey])){
                                if(unrestricted[restrictionKey]){
                                    timeRestricted = false
                                }
                            }
                        }
                    }
                }
            }
            let afterNow = dayjs().isBefore(this.currentStart)
            let isWithinWidgetAvailability
            if(this.targetDate){
                isWithinWidgetAvailability = ((this.targetType == 'within' && this.currentStart.isAfter(this.targetDate)) || (this.targetType == 'after' && this.currentEnd.isBefore(this.targetDate)));
            }

            let isWithinShift = false
            for(let shift of shifts){
                let shiftStart = dayjs(shift.startsAt)
                let shiftEnd = dayjs(shift.endsAt)
                if(!isWithinShift && 
                    (shiftStart.isBefore(this.currentStart) || shiftStart.isSame(this.currentStart)) && 
                    (shiftEnd.isAfter(this.currentEnd) || shiftEnd.isSame(this.currentEnd))){
                    isWithinShift = true
                }
            }
            let isWithinServiceTimes = false
            if(matchingServiceTimes.length == 0){
                isWithinServiceTimes = true
            }
            for(let matchingServiceTime of matchingServiceTimes){
                if(this.currentStart.isSameOrAfter(matchingServiceTime.startsAt) && this.currentEnd.isSameOrBefore(matchingServiceTime.endsAt)){
                    isWithinServiceTimes = true
                }
            }
            if(this.item.appointmentCounts){
                let appTotal = 0;
                for(let [time, count] of Object.entries(this.item.appointmentCounts || {})){
                    let [appStart, appEnd] = time.split('--')
                    appStart = dayjs(appStart)
                    appEnd = dayjs(appEnd)
                    if(appStart.isBefore(this.currentEnd) && appEnd.isAfter(this.currentStart)){
                        appTotal = appTotal + count
                    }
                }
                if(maxPatients < (appTotal + patientCount)){
                    unavailable = true
                }
            }
            if(!unavailable && !timeRestricted && afterNow && isWithinShift && isWithinServiceTimes && (!this.targetDate || isWithinWidgetAvailability)){
                let timeSlot = this.generateTimeSlot()
                timeSlots[`${timeSlot.id}`] = timeSlot
            }
            this.setCurrentStart(this.currentEnd)
            this.setCurrentEnd(this.currentEnd.add(this.duration, 'minute'))

            for(let i in matchingServiceTimes){
                if(matchingServiceTimes[i + 1]){
                    if(this.currentEnd.isAfter(matchingServiceTimes[i].endsAt) && this.currentStart.isBefore(matchingServiceTimes[i + 1].startsAt)){
                        this.setCurrentStart(matchingServiceTimes[i + 1].startsAt)
                        this.setCurrentEnd(matchingServiceTimes[i + 1].startsAt.add(this.duration, 'minute'))
                    }
                }
            }
        }
        return {value: timeSlots}
    }
    generateTimeSlot() {
        let timeSlot = {
            startsAt: this._currentStart.clone().format(),
            endsAt: this._currentEnd.clone().format(),
            administratorID: this.item.administratorID
        }
        timeSlot.id = `${timeSlot.administratorID}--S${this._currentStart.format("YYYY-MM-DD-HH-mm-ss")}--E${this._currentEnd.format("YYYY-MM-DD-HH-mm-ss")}`
        return timeSlot
    }
    get currentStart(){
        return this._currentStart.clone()
    }
    get currentEnd(){
        return this._currentEnd.clone().add(this.spacer, 'minutes')
    }
    setCurrentStart(currentStart){
        this._currentStart = currentStart
    }
    setCurrentEnd(currentEnd){
        this._currentEnd = currentEnd
    }
}

const process = ({item, appointmentType, patientCount, patients, serviceTimes, widgetAvailability, shifts, administrator}) => {
    return new ProcessTimeSlots({item, appointmentType, patientCount, patients, serviceTimes, widgetAvailability, shifts, administrator})
}
 
module.exports = process

module.exports.all = ({startingAt, data, shifts, appointmentType, widgetAvailability, patientCount, serviceRegionIDs, patients, administrators, Constructor}) => {

    let response = {}
    startingAt = dayjs(startingAt || dayjs()).startOf('day')
    let endingAt = startingAt.clone().add(1,'day').endOf('day')

    let serviceTimes = []
    if(appointmentType.serviceTimes.length > 0){
        serviceTimes = NILRepeating.all({
            data: appointmentType.serviceTimes, 
            startingAt: startingAt.clone().startOf("week").format(), 
            endingAt: endingAt.clone().endOf("week").format(), 
            recast: dayjs
        })
    }

    let _shifts = {}
    if(shifts){
        for(let adminID of Object.keys(shifts)){
            let filteredShifts = Object.values(shifts[adminID])
            if(serviceRegionIDs){
                filteredShifts = filteredShifts.filter((s)=>!s.serviceRegionID || serviceRegionIDs.includes(s.serviceRegionID))
            }
            _shifts[adminID] = (_shifts[adminID] || []).concat(
                NILRepeating.all({
                    data: filteredShifts, 
                    startingAt: startingAt.clone().startOf("week").format(),
                    endingAt: endingAt.clone().endOf("week").format(),
                    recast: dayjs
                })
            )
        }
    }

    for(let item of data){
        const appointmentTypeIDs = Object(administrators[item.administratorID]).appointmentTypeIDs || []
        if(appointmentTypeIDs.includes(appointmentType.id)){
            let startsAt = dayjs(item.startsAt)
            let endsAt = dayjs(item.endsAt)
            let itemShifts = (_shifts[item.administratorID] || []).filter((shift)=>dayjs(shift.startsAt).format("MM/DD/YYYY") == startsAt.format("MM/DD/YYYY"))
   
            if(!(startingAt.isAfter(endsAt) && endingAt.isBefore(startsAt))){
                let timeSlot = process({item,appointmentType,patientCount,patients,serviceTimes,widgetAvailability, shifts: itemShifts, administrator: administrators[item.administratorID]}).value
                response[`${item.administratorID}`] = {...response[`${item.administratorID}`], ...timeSlot}
            }
        }
    }

    if(Constructor){
        response = response.map((row)=>
            new Constructor(row)
        );
    }

    return response
}


// WEBPACK FOOTER //
// ./lib/helpers/ProcessTimeSlots.js